import React from "react";

import "./loadIconBtn.css";

export default function LoadIconBtn() {
  return (
    <div className="lds-ripple">
      <div></div>
      <div></div>
    </div>
  );
}
